import { render, staticRenderFns } from "./AddJurisdiction.vue?vue&type=template&id=0dd469a0&scoped=true"
import script from "./AddJurisdiction.vue?vue&type=script&lang=js"
export * from "./AddJurisdiction.vue?vue&type=script&lang=js"
import style0 from "./AddJurisdiction.vue?vue&type=style&index=0&id=0dd469a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dd469a0",
  null
  
)

export default component.exports